<template>
  <sc-dialog title="图表" v-model="visible" :width="ismobile ? '90%' : '80%'" destroy-on-close @closed="handleClose">
    <scEcharts height="500px" :option="option"></scEcharts>
  </sc-dialog>
</template>

<script setup>
import scEcharts from '@/components/scEcharts';
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
const store = useStore()

const emit = defineEmits(['closed'])

const visible = ref(false)
const option = ref({})

// 计算属性
const ismobile = computed(() => store.state.global.ismobile)

const handleClose = () => {
  visible.value = false
  emit('closed')
}
const open = async (params) => {
  visible.value = true
  option.value = params || {}
}
defineExpose({ open })
</script>

<style lang="scss" scoped></style>